module.exports = __webpack_public_path__ + "img/t1-duo-1.72f1683a.jpg";